const start_date = $("#timeslot_start_date").val();
const end_date = $("#timeslot_end_date").val();
const monday = $('#v-pills-monday');
const tuesday = $('#v-pills-tuesday');
const wednesday = $('#v-pills-wednesday');
const thursday = $('#v-pills-thursday');
const friday = $('#v-pills-friday');
const saturday = $('#v-pills-saturday');
const sunday = $('#v-pills-sunday');
const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

$(document).ready( function(){
    //Datepicker code
    $('#timeslotDatepicker').daterangepicker({
        "singleDatePicker": true,
        "startDate": "04/01/2021",
        "endDate": "04/01/2021",
        "autoApply": true,
        "minDate": start_date,
        "maxDate": end_date,
    });
});

$(document).ready(function(){
    function getWeekDaysAndCalcSpots(){
        const date = $("#timeslotDatepicker").val();
        const event_id = $("#event_id").val();
        const tabs = $('#v-pills-tab');
        //Here we get the timeslots from an php function
        if (date) {
            $.ajax({
                type: 'get',
                url: '/frame/calculateTimeslots',
                data:{'date': date, 'event_id': event_id},
                success:function(data){
                    let invalidButton;
                    let validButton;
                    let selectedDate;
                    let tab;
                    let loop = 0;
                    tabs.html(" ");

                    clear();

                    //Here we append all the timeslots that we collected from the php function
                    for(let i = 0; i < days.length; i++) {
                        const currentDay = days[i];
                        if (currentDay !== undefined) {
                            if (checkIfBefore(data.data[currentDay][0][currentDay]['date']) && checkIfAfter(data.data[currentDay][0][currentDay]['date'])) {
                                //Here we check if this is the first loop (first day) and if so we make it active.
                                if (loop === 0){
                                    loop++;
                                    tab = '<a class="nav-link active" data-toggle="pill" href="#v-pills-'+currentDay+'" role="tab">'+capitalize(currentDay)+'</a>'
                                    $("#v-pills-"+currentDay).addClass("active show");
                                }else{
                                    tab = '<a class="nav-link" data-toggle="pill" href="#v-pills-'+currentDay+'" role="tab">'+capitalize(currentDay)+'</a>'
                                }
                                tabs.append(tab);

                                selectedDate = '<h3>' + data.data[currentDay][0][currentDay]['date'] + '</h3> <hr>'
                                thisAppend(currentDay, selectedDate);

                                for (let i = 0; i < data.data[currentDay].length; i++) {
                                    if (data.data[currentDay][i][currentDay]['disabled'] === false) {
                                        if (data.data[currentDay][i][currentDay]['spots'] === 0) {
                                            invalidButton = '<button class="btn btn-outline-secondary m-1" disabled>' + data.data[currentDay][i][currentDay]['time'] + ' (Fully booked)</button>';
                                            thisAppend(currentDay, invalidButton);
                                        } else {
                                            validButton = '<button class="btn btn-outline-secondary m-1 mr-2" name="timeslot" value="' + data.data[currentDay][i][currentDay]['time'] + '|  ' + data.data[currentDay][i][currentDay]['date'] + '">' + data.data[currentDay][i][currentDay]['time'] + ' (' + data.data[currentDay][i][currentDay]['spots'] + ' available)</button>';
                                            thisAppend(currentDay, validButton);
                                        }
                                    } else {
                                        invalidButton = '<button class="btn btn-outline-secondary m-1" disabled>' + data.data[currentDay][i][currentDay]['time'] + ' (Closed)</button>';
                                        thisAppend(currentDay, invalidButton);
                                    }
                                }
                            }
                        }
                    }

                }
            });

        }
    }

    getWeekDaysAndCalcSpots();

    $('#timeslotDatepicker').on('change',function() {
        //If a different date is selected re-generate the timeslots.
        getWeekDaysAndCalcSpots();
    });
});

function clear(){
    monday.html(" ");
    monday.removeClass("active show");
    tuesday.html(" ");
    tuesday.removeClass("active show");
    wednesday.html(" ");
    wednesday.removeClass("active show");
    thursday.html(" ");
    thursday.removeClass("active show");
    friday.html(" ");
    friday.removeClass("active show");
    saturday.html(" ");
    saturday.removeClass("active show");
    sunday.html(" ");
    sunday.removeClass("active show");
}
function checkIfBefore(check){
    var currentDate = new Date(check)
    var startDate = new Date(start_date)

    return currentDate >= startDate;
}
function checkIfAfter(check){
    var currentDate = new Date(check)
    var endDate = new Date(end_date)

    return currentDate <= endDate;
}
function capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
}
function thisAppend(type, data){
    switch(type) {
        case 'monday':
            monday.append(data)
            break;
        case 'tuesday':
            tuesday.append(data)
            break;
        case 'wednesday':
            wednesday.append(data)
            break;
        case 'thursday':
            thursday.append(data)
            break;
        case 'friday':
            friday.append(data)
            break;
        case 'saturday':
            saturday.append(data)
            break;
        case 'sunday':
            sunday.append(data)
            break;
    }
}
